import React, { lazy } from 'react';

const IncentivesComponent = lazy(
  () => import(/* webpackChunkName: "carvana-purchase-incentives" */ './incentives')
);

export const IncentivesRoute = () => {
  return <IncentivesComponent />;
};
